export const LOGIN_MFA_VERIFICATION_FAILURES = {
    INVALID_CODE: {
        code: 'login_mfa_code_invalid',
        message: 'The verification code is invalid.',
        remediation: 'retry_mfa_code',
        statusCode: 401,
    },
    CHALLENGE_EXPIRED: {
        code: 'login_mfa_challenge_expired',
        message: 'The verification challenge has expired.',
        remediation: 'resend_login_mfa',
        statusCode: 410,
    },
    RECOVERY_REQUIRED: {
        code: 'login_mfa_recovery_required',
        message: 'Account recovery is required before verification can continue.',
        remediation: 'account_recovery',
        statusCode: 423,
    },
};
const FAILURE_BY_CODE = new Map(Object.values(LOGIN_MFA_VERIFICATION_FAILURES).map((failure) => [failure.code, failure]));
export function createLoginMfaVerificationFailureResponse(code) {
    switch (code) {
        case 'login_mfa_code_invalid':
            return {
                error: 'login_mfa_verification_failed',
                code,
                message: LOGIN_MFA_VERIFICATION_FAILURES.INVALID_CODE.message,
                remediation: { type: LOGIN_MFA_VERIFICATION_FAILURES.INVALID_CODE.remediation },
                statusCode: LOGIN_MFA_VERIFICATION_FAILURES.INVALID_CODE.statusCode,
            };
        case 'login_mfa_challenge_expired':
            return {
                error: 'login_mfa_verification_failed',
                code,
                message: LOGIN_MFA_VERIFICATION_FAILURES.CHALLENGE_EXPIRED.message,
                remediation: { type: LOGIN_MFA_VERIFICATION_FAILURES.CHALLENGE_EXPIRED.remediation },
                statusCode: LOGIN_MFA_VERIFICATION_FAILURES.CHALLENGE_EXPIRED.statusCode,
            };
        case 'login_mfa_recovery_required':
            return {
                error: 'login_mfa_verification_failed',
                code,
                message: LOGIN_MFA_VERIFICATION_FAILURES.RECOVERY_REQUIRED.message,
                remediation: { type: LOGIN_MFA_VERIFICATION_FAILURES.RECOVERY_REQUIRED.remediation },
                statusCode: LOGIN_MFA_VERIFICATION_FAILURES.RECOVERY_REQUIRED.statusCode,
            };
        default:
            return assertNever(code);
    }
}
export function parseLoginMfaVerificationFailureResponse(value, actualHttpStatus) {
    if (!isRecord(value) || !isRecord(value['remediation']))
        return null;
    const code = value['code'];
    if (typeof code !== 'string')
        return null;
    const failure = FAILURE_BY_CODE.get(code);
    if (!failure ||
        value['error'] !== 'login_mfa_verification_failed' ||
        value['statusCode'] !== failure.statusCode ||
        actualHttpStatus !== failure.statusCode ||
        typeof value['message'] !== 'string' ||
        value['message'].trim().length === 0 ||
        value['remediation']['type'] !== failure.remediation) {
        return null;
    }
    return createLoginMfaVerificationFailureResponse(failure.code);
}
function isRecord(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
function assertNever(value) {
    throw new TypeError(`Unsupported login MFA failure code: ${String(value)}`);
}
//# sourceMappingURL=login-mfa-verification.js.map